export default "__VITE_ASSET__yi4yyD4h__"